module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_21_1.711fa0e1.jpeg";